import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager,
    Keyboard

} from "react-native"
import {typeExport} from "../../../../redux/store/type";
import {moderateScale} from "../../../../tools/Scaling";
import * as Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import HMTextInput from "../../../../customviews/HMTextInput";
import i18n from "../../../../I18n/i18n";
import {Tools} from "../../../../tools/Tools";
import * as NavigationService from "../../../../redux/NavigationService";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMAlert from "../../../../customviews/HMAlert";
import PathFile from "../../../../assets/PathFile";
import HMDialogWifiCheck from "../../../../customviews/HMDialogWifiCheck";
import wifi from "../../../../importCalss/wifi";
//import axios from "axios";
import HMIcon from "../../../../customviews/HMIcon";
import RNOtpVerify from 'react-native-otp-verify';

let content = null;
let HashCode = null;
export default class LoginEnterUsernameSatiaScreen extends Component {

    constructor(props) {
        super(props);
        content = this;
        this.state = {
            mobile: '',
            otp: null
        }

    }


    componentWillReceiveProps(props) {


    }


    getData() {

        if (this.props.DataSplashScreen.Connection) {
            let {mobile, password, username} = this.state;
            global._mobile = mobile
            //let checkTypeLogin = this.props.route.params && this.props.route.params.type == "forgot_my_password";
            this.setState({
                    Once: true
                },
                () => {


                    let paramss = {
                        "_operation": typeExport._Registration,
                        "lang": i18n.locale,
                        "mode": typeExport._sendCodeMode,
                        //   "forgotmode": checkTypeLogin && !global.registerLogin ? "1" : "0",
                        "username": username,
                        "password": password,
                        "HashCode": HashCode,
                    };


                    this.props.callService(
                        // typeExport._baseUrlSatia + "user/sendcode",
                        typeExport._baseUrlSatia + (typeExport._NameApp == "Satia" ? "user/loginUserName" : "operator/login"),
                        paramss,
                        typeExport.TypegetDataLoginEnterUsernameSatiaScreen,
                        "POST",
                        this.state
                    );
                }
            )

        } else
            this.props.callServiceError("offline")


    }

    checkMobile(text) {

        text = Tools.persianToEnglish(text)

        const reg = /^([0]|| [98])?09\d{9}$/;
        if (reg.test(text) === false) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkMobile'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
            //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

        } else {
            this.getData()
            /*  if (Tools.CheckValue(this.state.password) === null || this.state.password.trim().length <= 3) {
                  HMAlert(
                      i18n.t('constant.message'),
                      i18n.t('constant.checkPassword'),
                      [
                          // {text: 'Ask me later', onPress: () => {}},
                          // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                          {text: i18n.t('constant.ok'), onPress: () => {}},
                      ],
                      {cancelable: true}
                  )
                  //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

              } else {
                  //  this.loadingButton.showLoading(true);
                  this.setState({
                          // mobile: text,
                      }
                      ,
                      () => {
                          this.getData()
                      }
                  );

              }*/

        }

    }

///////// SMS ///////
    // Actions
    getHash = () =>
        RNOtpVerify.getHash()
            .then((data) => {
                HashCode = data;
            })
            .catch(console.log);


/////////
    componentDidMount() {
        if (Platform.OS === "android") {

            this.getHash()
        }


        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {mobile, username, password} = this.state;
        return (
            <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>
                <View style={{flex: 1,}}>

                    <View
                        style={{
                            flex: .4,
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: Colors.colorPrimary
                        }}
                    >
                        {/*    <HMTextView
                            style={{
                                color: "#fff",
                                fontSize: moderateScale(34),
                                //fontSize:moderateScale(16)
                            }}
                            text={i18n.t('appName')}
                            type={"bold"}
                        />*/}

                        <Image

                            //resizeMode={"stretch"}
                            style={{
                                width: moderateScale(80),
                                height: moderateScale(42),

                                //position: 'absolute',
                                //borderRadius: 50),
                                //     backgroundColor: Colors.white


                            }}
                            // source={require('../../../assets/img/logo.png')}
                            source={PathFile.image.name_satia}
                            //source={{uri: "https://painrelief-blog.org/wp-content/uploads/2019/07/5d2233166143e.jpg"}}
                        />

                    </View>

                    <View style={{
                        flex: .6,
                        padding: moderateScale(14),
                        //backgroundColor:"#ee0038"
                    }}>
                        {/*             <HMTextView
                  style={{
                      //fontSize:moderateScale(16)
                  }}
                  text={"ساتیا"}
                  type={"bold"}
              />*/}

                        <HMTextInput
                          //  _ref={(ref) => this.valueRefUsername = ref}
                            onRef={(ref) => { this.valueRefUsername = ref?.textInput }}
                            // style={{height: moderateScale(40),
                            //     borderColor: 'gray',
                            //     borderWidth: moderateScale(1),
                            //     textAlign: I18nManager.isRTL && Platform.OS!=='web'? 'right' : 'left',
                            //
                            // }}
                            title={"نام کاربری"}
                            placeholder={'نام کاربری خود را وارد نمایید'}

                            // lang
                            styleTitle={{color: Colors.blackLight}}
                            onChangeText={text => this.onChangeText("username", text)}
                            onSubmitEditing={() => {
                                //this.checkMobile(this.state.username)
                            }}
                            // onPressClear={() => this.onChangeText("value", null)}
                            onPressClear={() => {
                                this.onChangeText("username", null)
                                this.valueRefUsername.clear()
                            }}
                            value={username}
                            //   keyboardType="numeric"
                        />
                        <HMTextInput
                          //  _ref={(ref) => this.valueRefPassword = ref}
                            onRef={(ref) => { this.valueRefPassword = ref?.textInput }}
                            // style={{height: moderateScale(40),
                            //     borderColor: 'gray',
                            //     borderWidth: moderateScale(1),
                            //     textAlign: I18nManager.isRTL && Platform.OS!=='web'? 'right' : 'left',
                            //
                            // }}
                            title={'رمز عبور'}
                            placeholder={'رمز عبور خود را وارد نمایید'}

                            //lang
                            styleTitle={{color: Colors.blackLight}}
                            onChangeText={text => this.onChangeText("password", text)}
                            onSubmitEditing={() => {
                                this.getData()

                            }}
                            // onPressClear={() => this.onChangeText("value", null)}
                            onPressClear={() => {
                                this.onChangeText("password", null)
                                this.valueRefPassword.clear()
                            }}
                            value={password}
                            secureTextEntry={true}
                            //    keyboardType="numeric"
                        />

                        <View style={{
                            width: '100%', flexDirection: "row",
                            // alignItems: 'flex-end',
                            justifyContent: 'space-between',

                        }}>
                            <TouchableOpacity
                                style={{
                                    width: moderateScale(0),
                                    height: moderateScale(0),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(10),
                                    overflow: "hidden"
                                    //  backgroundColor: Colors.colorPrimary,
                                    //  borderRadius: moderateScale(6),
                                }}
                                onPress={() => {
                                    //    NavigationService.navigate('EnterCodeSatiaScreen', { userName: 'Lucy' });
                                    if (Platform.OS === "web")
                                        NavigationService.navigateParams("InformationSatiaScreen")
                                    else
                                        Tools.GoLink("https://app.satia.co/r")
                                    //this.checkMobile(this.state.mobile)
                                }}
                            >
                                <HMTextView
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.colorPrimary
                                    }}
                                    text={"ثبت اشتراک جدید"}
                                    //lang
                                    type={"bold"}
                                />
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={{
                                    width: moderateScale(120),
                                    height: moderateScale(40),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginVertical: moderateScale(6),
                                    backgroundColor: Colors.colorPrimary,
                                    borderRadius: moderateScale(6),
                                }}
                                onPress={() => {
                                    //    NavigationService.navigate('EnterCodeSatiaScreen', { userName: 'Lucy' });

                                    //    NavigationService.navigateParams("InformationSatiaScreen")
                                    this.getData()
                                }}
                            >
                                <HMTextView
                                    style={{
                                        //fontSize:moderateScale(16)
                                    }}
                                    text={"constant.Login"}
                                    lang
                                    type={"bold"}
                                />
                            </TouchableOpacity>

                        </View>

                        {
                            Platform.OS === "android" ?

                                // WiFiReview && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?

                                <TouchableOpacity


                                    style={{
                                        width: '50%',
                                        backgroundColor: Colors.colorPrimary,
                                        // height:moderateScale(40),
                                        padding: moderateScale(10),
                                        marginHorizontal: moderateScale(10),
                                        marginTop: moderateScale(20),
                                        borderRadius: moderateScale(8),
                                        alignSelf: 'center',
                                    }}
                                    onPress={() => {
                                        this.setState({
                                            WifiCheck: true
                                        })
                                    }}
                                >
                                    <View style={{flexDirection: "row", alignSelf: 'center',}}>
                                        <HMIcon name={"wifi"}
                                            // type={"FontAwesome"}
                                                style={{
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.white,
                                                    width: moderateScale(29),
                                                    height: moderateScale(29),
                                                    fontSize: moderateScale(24)
                                                }}/>
                                        <View style={{width: moderateScale(10)}}/>
                                        <HMTextView
                                            type={"bold"}
                                            //text={i18n.t('constant.WiFiReview')}
                                            text={"اتصال با هات اسپات"}
                                            style={{color: "white", fontSize: moderateScale(14)}}
                                        />

                                    </View>
                                </TouchableOpacity>

                                :
                                null
                        }
                    </View>
                    {
                        this.state.WifiCheck ?
                            // !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?

                            <HMDialogWifiCheck onPressCancel={() => {
                                this.setState({
                                    WifiCheck: false
                                })
                            }} func={null
                                //this.checkMobile
                            }/>
                            : null
                    }
                    {
                        this.props.NoInternetDialog ?
                            <DialogConnectionCustomize
                                again
                                // WiFiReview={this.state.showButtonWifi}
                                //
                                // // showButtonWifi={()=>{showButtonWifi:false}}
                                // onPressWiFiReview={async () => {
                                //     this.setState({
                                //         WifiCheck: true
                                //     })
                                // }}
                                //   onPress={() => this.checkMobile(this.state.mobile)}
                                // onPress={() => {
                                //     this.props.callServiceRefresh()
                                // }}
                            />
                            :
                            null
                    }
                    {
                        this.props.NoInternetDialog ?
                            <DialogConnectionCustomize
                                onPress={() => this.getData()
                                }
                            />
                            :
                            null
                    }

                    {
                        this.props.isLoading ?
                            <DialogLoadingCustomize/>
                            : null
                    }

                </View>
            </KeyboardAvoidingView>
        );
    }
    onChangeText(name, text) {
        // console.log("ahmad1", this.state, name, text)
        this.setState({[name]: text}, () => {
            //  console.log("@@@@@", this.state)
        });
    }

}
